<template>
  <div id="map-controls-sidebar-filter">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeFilterSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">フィルター</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_FILTER_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY" />

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-2 pb-10"
          :settings="settings"
          :key="$vs.rtl"
        >
          <vs-collapse>
            <vs-collapse-item>
              <div
                class="aisea-text-16-400-white"
                slot="header"
                id="filters-vessel-collapse-item-header"
              >
                船舶種別
              </div>
              <Vessel-type></Vessel-type>
            </vs-collapse-item>

            <vs-collapse-item class="mt-4">
              <div
                class="aisea-text-16-400-white"
                slot="header"
                id="filters-plot-collapse-item-header"
              >
                プロット種別
              </div>
              <plot-Type></plot-Type>
            </vs-collapse-item>

            <vs-collapse-item class="mt-4">
              <div
                class="aisea-text-16-400-white"
                slot="header"
                id="filters-navigation-collapse-item-header"
              >
                航路標識種別
              </div>
              <navigation-type></navigation-type>
            </vs-collapse-item>

            <vs-collapse-item class="mt-4" v-if="hasRadarGridAddon">
              <div
                class="aisea-text-16-400-white"
                slot="header"
                id="filters-radar-grid-collapse-item-header"
              >
                レーダーグリッド
              </div>
              <radar-grid-type></radar-grid-type>
            </vs-collapse-item>
          </vs-collapse>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VesselType from "./items/VesselType";
import PlotType from "./items/PlotType";
import NavigationType from "./items/NavigationType";
import RadarGridType from "./items/RadarGridType";
import { createNamespacedHelpers } from "vuex";
import AuthService from "@/services/authService";

// Mixins
import { ColorMixin } from "@/mixins";

const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
    VesselType,
    PlotType,
    NavigationType,
    RadarGridType,
  },
  data() {
    return {
      init: false,
      active: false,
      type: "margin",
      settings: {
        maxScrollbarLength: 50,
        wheelSpeed: 0.6,
      },
      activePlotCollapse: false,
      activeNavigationCollapse: false,
    };
  },
  watch: {
    activeFilterSidebar(val) {
      if (val) {
        if (!this.init) {
          setTimeout(() => {
            this.onClickCollapse();
          }, 500);
          this.init = true;
        }
      }
    },
  },
  computed: {
    ...mapStateOfLiveMap({
      activeFilterSidebar: state => state.activeFilterSidebar,
    }),
    footerTypeLocal: {
      get() {
        return this.footerType;
      },
      set(val) {
        this.$emit("updateFooter", val);
      },
    },
    hideScrollToTopLocal: {
      get() {
        return this.hideScrollToTop;
      },
      set(val) {
        this.$emit("toggleHideScrollToTop", val);
      },
    },
    rtl: {
      get() {
        return this.$vs.rtl;
      },
      set(val) {
        this.$vs.rtl = val;
      },
    },
    themeMode: {
      get() {
        return this.$store.state.theme;
      },
      set(val) {
        this.$store.dispatch("updateTheme", val);
      },
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    hasRadarGridAddon() {
      return this.$store.state.addons.some(
        obj => obj.id === AuthService.ADDON_IDS.RADAR_GRID
      );
    },
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_ACTIVE_FILTER_SIDEBAR"]),
    updatePrimaryColor(color) {
      this.primaryColor = color;
      this.$vs.theme({ primary: color });
    },
    onClickCollapse() {
      document.getElementById("filters-vessel-collapse-item-header").click();
      document.getElementById("filters-plot-collapse-item-header").click();
      document
        .getElementById("filters-navigation-collapse-item-header")
        .click();
      document
        .getElementById("filters-radar-grid-collapse-item-header")
        .click();
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-filter {
  .vs-collapse-item--header {
    padding-left: 0;
  }

  .vs-collapse {
    padding: 0 20px 20px;
  }

  .vs-collapse-item--content {
    border-radius: 5px;
  }

  .header-label {
    color: $aisea-white;
  }

  .icon-header {
    color: $aisea-white;
  }

  .con-content--item {
    background-color: $aisea-blue-gray;
  }

  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
    }
  }

  .vs-collapse-item {
    border-bottom: 0;
  }
}
</style>
